import { MAX_NEP_YEAR as e, MIN_NEP_YEAR as t } from "../../../calendar-carburettor/constants/index.js";
import { zero_pad as n } from "../../../calendar-carburettor/zero-pad/index.js";
import { englishMonthMap as r, months as i } from "../../../calendar-engine/constants/calendar-date.js";
import { NEPALI_DATE as a } from "../../../calendar-engine/use-cases/nepali_date/index.js";
import { parse_date as o } from "../../../calendar-engine/utilities/parse_date.js";
import { range as s } from "../../../calendar-engine/utilities/range.js";
import { stitch_date as c } from "../../../calendar-engine/utilities/stitch_date.js";
import { getSelectionAnchorDate as l, normalizeDisabledDates as u } from "../../../utilities/index.js";
import { get_year_list_in_decade as d, parseSafeDate as f, validate as p } from "../../../utilities/utils.js";
import { ad2bs as m, bs2ad as h } from "../../../calendar-carburettor/converter/index.js";
import { isDateInConversionRange as g } from "../../../calendar-carburettor/is-date-in-conversion-range/index.js";
import { ErrorMessage as _ } from "../../config/index.js";
import { ModeEnum as v, ViewModeEnum as y } from "../../models/model.js";
import { completeDate as b } from "./english-strategy.js";
import x from "dayjs";
import { englishToNepaliNumber as S, nepaliToEnglishNumber as C } from "nepali-number";
import w from "tiny-invariant";
// src/design/forms/datepicker/core/libs/strategy/nepali-strategy.ts
var T = x().format("YYYY-MM-DD"), E = {
	setWeeks: () => {},
	setDate: (e) => (t, n) => {
		e && (t.next[t.next.currentDateSelection] = e), n();
	},
	setDateForTypingEvent: (e) => (t, n) => {
		e ? g(e, !0) && p(e, t.next.disableDateBefore, t.next.disableDateAfter).is_valid && (t.next[t.next.currentDateSelection] = h(e), n()) : (t.next[t.next.currentDateSelection] = "", n());
	},
	setConvertedDate: (e) => (t, n) => {
		if (t.next.mode === v.RANGE) {
			let n = e;
			n.startDate && n.endDate && (t.next.startDate = f(n.startDate), t.next.endDate = f(n.endDate));
		} else t.next.startDate = f(e.startDate);
		n();
	},
	setCalendarReferenceDate: () => function(e, t) {
		let n = l(e.next);
		e.next.calendarReferenceDate = n ? b(n) : T, t();
	},
	setDisableDateBefore: (e) => (t, n) => {
		(e.length >= 10 || e.length === 0) && (t.next.disableDateBefore = e ? x(e).format("YYYY-MM-DD") : ""), n();
	},
	setDisableDateAfter: (e) => (t, n) => {
		(e.length >= 10 || e.length === 0) && (t.next.disableDateAfter = e ? x(e).format("YYYY-MM-DD") : ""), n();
	},
	setIsTodayValid: (e) => function(t, n) {
		let r = "";
		t?.next?.disableDateBefore && (r = t.next.disableDateBefore);
		let i = "";
		t?.next?.disableDateAfter && (i = t.next.disableDateAfter);
		let a = p(e, r, i);
		t.next.isTodayValid = a.is_valid, n();
	},
	setGridDatesWithMeta: (e, t) => {
		e.next.calendarReferenceDate && w(g(e.next.calendarReferenceDate, !1), "Calendar reference date should be in conversion range!"), e.next[e.next.currentDateSelection] && w(g(e.next[e.next.currentDateSelection], !1), "Date should be in conversion range!");
		let n = e.next.disableDateAfter, c = e.next.disableDateBefore;
		if (v.RANGE === e.next.mode) {
			let t = u({
				startDate: e.next.startDate,
				endDate: e.next.endDate
			}, {
				disableDateBefore: e.next.disableDateBefore || "",
				disableDateAfter: e.next.disableDateAfter || ""
			}, e.next.currentDateSelection);
			c = t.disableDateBefore, n = t.disableDateAfter;
		}
		let l = m(e.next.calendarReferenceDate), d = o(l), f = a.get_weeks_in_month(d), p = s(0, f), h = s(1, 7), _ = p.map((t) => h.map((r) => a.get_day_info({
			weekNum: t,
			weekDayNum: r,
			calendarReferenceDate: o(m(e.next.calendarReferenceDate)),
			date: o(m(e.next[e.next.currentDateSelection])),
			disable_date_before: c,
			disable_date_after: n,
			disabledWeekDays: e.next.disabledWeekDays,
			holidays: e.next.holidays,
			weekSelectionEnabled: e.next.mode === v.WEEK,
			weekAnchorDate: e.next.startDate
		})));
		e.next.gridDatesWithMeta.gridDates = _;
		let [y, b] = m(e.next.calendarReferenceDate).split("-");
		e.next.gridDatesWithMeta.primaryYear = +y, e.next.gridDatesWithMeta.primaryMonth = i.ne[b - 1];
		let [x] = e.next.calendarReferenceDate.split("-");
		e.next.gridDatesWithMeta.secondaryYear = +x, e.next.gridDatesWithMeta.secondaryMonthCombination = r[parseInt(b + "") - 1], t();
	},
	setMonthYearPanelData: (e, t) => {
		if (e.next.isOpen) {
			let [t, n] = e.next.calendarReferenceDate.split("-"), i = e.next.calendarReferenceDate?.split("-") ?? [], a = C(i[0]);
			e.next.monthYearPanelData = `${r[parseInt(n + "") - 1]} ${a}`;
		}
		t();
	},
	setCalendarControllerLabels: function(e, t) {
		if (e.next.isOpen) {
			let [t, n] = m(e.next.calendarReferenceDate).split("-");
			e.next.controllerLabel.month = i.ne[n - 1], e.next.controllerLabel.year = S(t);
		}
		t();
	},
	incrementMonth: function(e, t) {
		let r = m(e.next.calendarReferenceDate);
		if (r) {
			let [e, t] = r.split("-"), i = parseInt(t), a = parseInt(e);
			i = parseInt(t + "") + 1, i === 13 && (i = 1, a = parseInt(e + "") + 1), r = `${a}-${n(i)}-01`;
		}
		e.next.calendarReferenceDate = h(r), t();
	},
	decrementMonth: function(e, t) {
		let r = m(e.next.calendarReferenceDate);
		if (r) {
			let [e, t] = r.split("-"), i = parseInt(t), a = parseInt(e);
			i = parseInt(t + "") - 1, i === 0 && (i = 12, a = parseInt(e + "") - 1), r = `${a}-${n(i)}-01`;
		}
		e.next.calendarReferenceDate = h(r), t();
	},
	incrementYear: function(e, t) {
		e.next.calendarReferenceDate = x(e.next.calendarReferenceDate).add(1, "year").format("YYYY-MM-DD"), t();
	},
	decrementYear: function(e, t) {
		e.next.calendarReferenceDate = x(e.next.calendarReferenceDate).subtract(1, "year").format("YYYY-MM-DD"), t();
	},
	incrementDecade: function(e, t) {
		e.next.calendarReferenceDate = x(e.next.calendarReferenceDate).add(10, "year").format("YYYY-MM-DD"), t();
	},
	decrementDecade: function(e, t) {
		e.next.calendarReferenceDate = x(e.next.calendarReferenceDate).subtract(10, "year").format("YYYY-MM-DD"), t();
	},
	setViewModeToMonth: function(e, t) {
		e.next.viewMode = y.MONTH_VIEW, t();
	},
	setViewModeToYear: function(e, t) {
		e.next.viewMode = y.YEAR_VIEW, t();
	},
	setViewModeToCalendar: function(e, t) {
		e.next.viewMode = y.CALENDAR_VIEW, t();
	},
	setGridYears: function(n, r) {
		let i = +m(n.next.calendarReferenceDate).split("-")[0], a = d(i, e, t);
		n.next.gridYears = [], n.next.gridYears = [
			a[0] - 1,
			...a,
			a[a.length - 1] + 1
		], r();
	},
	updateGridYearWithPreviousDecade: function(e, n) {
		let r = e.next.gridYears[0], i = d(r, -1, t);
		e.next.gridYears = [], e.next.gridYears = [
			i[0] - 1,
			...i,
			i[i.length - 1] + 1
		], n();
	},
	updateGridYearWithNextDecade: function(t, n) {
		let r = t.next.gridYears[t.next.gridYears.length - 1], i = d(r, e, -1);
		t.next.gridYears = [], t.next.gridYears = [
			i[0] - 1,
			...i,
			i[i.length - 1] + 1
		], n();
	},
	selectYear: (e) => (t, n) => {
		let r = m(t.next.calendarReferenceDate), i = c({
			year: e,
			month: +r.split("-")[1],
			day: 1
		}), a = h(i);
		t.next.calendarReferenceDate = a, n();
	},
	selectMonth: (e) => (t, n) => {
		let r = m(t.next.calendarReferenceDate), i = c({
			year: +r.split("-")[0],
			month: e,
			day: 1
		}), a = h(i);
		t.next.calendarReferenceDate = a, n();
	},
	checkIfTodayIsValid: function(e, t) {
		let { disableDateBefore: n, disableDateAfter: r } = e.next;
		p(T, n, r).is_valid && t();
	},
	checkIfStartDateIsBeforeEndDate: function(e, t) {
		if (e.next.mode === v.SINGLE) return t();
		let n = e.next.startDate, r = e.next.endDate;
		n === r ? (e.next.error = "", e.next?.onError?.(""), t()) : (n && r && (x(n).isBefore(x(r)) ? (e.next.error = "", e.next?.onError?.("")) : (e.next.error = "start date cannot be after end date", e.next?.onError?.(_.START_AND_END_DATE_BOUNDS))), t());
	},
	setTodayAsDate: (e) => function(t, n) {
		t.next.mode === v.WEEK ? (t.next.startDate = x(e).startOf("week").format("YYYY-MM-DD"), t.next.endDate = x(e).endOf("week").format("YYYY-MM-DD")) : t.next[t.next.currentDateSelection] = e, n();
	},
	setTodayAsCalendarReferenceDate: function(e, t) {
		e.next.calendarReferenceDate = T, t();
	},
	closeCalendarPicker: function(e, t) {
		e.next.closeOnSelect && (e.next.isOpen = !1), t();
	},
	checkIfDateIsValid: function(e, t) {
		let n = "";
		e?.next?.disableDateBefore && (n = e.next.disableDateBefore);
		let r = "";
		e?.next?.disableDateAfter && (r = e.next.disableDateAfter);
		let i = p(e.next?.[e.next.currentDateSelection] ? e.next?.[e.next.currentDateSelection] : "", n, r);
		if (!i.is_valid) return e.next.error = i.message, e.next?.onError?.(i.message), t();
		e.next.error = "", e.next?.onError?.(""), t();
	},
	convertdatesToCurrentContext: function(e, t) {
		t();
	},
	normalizeDates: function(e, t) {
		e.next[e.next.currentDateSelection] && (e.next[e.next.currentDateSelection] = m(e.next[e.next.currentDateSelection])), t();
	},
	setGridMonths: function(e, t) {
		e.next.gridMonths = i.ne, t();
	},
	sendChanges: (e, t) => {
		e.next.mode === v.RANGE || e.next.mode === v.WEEK ? e?.next?.onChange?.({
			startDate: e.next.startDate,
			endDate: e.next.endDate
		}) : e?.next?.onChange?.(e.next.startDate), t();
	},
	sendWeekChanges: function(e, t) {
		let n = x(e.next.startDate).startOf("week").format("YYYY-MM-DD"), r = x(e.next.startDate).endOf("week").format("YYYY-MM-DD");
		e.next.onChange?.({
			startDate: n,
			endDate: r
		}), t();
	},
	setStartAndEndDate: (e, t) => (n, r) => {
		n.next.startDate = e, n.next.endDate = t, r();
	},
	setYearGridDates: function(e, t) {
		if (e.next.isOpen) {
			let [t] = m(T).split("-"), r = Array.from({ length: 12 }, (e, r) => `${t}-${n(r + 1)}-01`).map((e) => h(e));
			e.next[e.next.currentDateSelection] && w(g(e.next[e.next.currentDateSelection], !1), "Date should be in conversion range!");
			let i = e.next.disableDateAfter, c = e.next.disableDateBefore;
			e.next.yearGridDates = [], r.forEach((t) => {
				t && w(g(t, !1), "Calendar reference date should be in conversion range!");
				let n = a.get_weeks_in_month(o(m(t))), r = s(0, n), l = s(1, 7);
				e.next.yearGridDates.push(r.map((n) => l.map((r) => a.get_day_info({
					weekNum: n,
					weekDayNum: r,
					calendarReferenceDate: o(m(t)),
					date: o(m(e.next[e.next.currentDateSelection])),
					disable_date_before: c,
					disable_date_after: i,
					disabledWeekDays: e.next.disabledWeekDays,
					holidays: e.next.holidays,
					weekSelectionEnabled: e.next.mode === v.WEEK,
					weekAnchorDate: e.next.startDate
				}))));
			});
		}
		t();
	},
	setYearGridDatesWithMeta: (e, t) => {
		if (e.next.isOpen) {
			let [t] = m(e.next.calendarReferenceDate).split("-"), c = Array.from({ length: 12 }, (e, r) => `${t}-${n(r + 1)}-01`).map((e) => h(e));
			e.next[e.next.currentDateSelection] && w(g(e.next[e.next.currentDateSelection], !1), "Date should be in conversion range!");
			let l = e.next.disableDateAfter, u = e.next.disableDateBefore;
			e.next.yearGridDatesWithMeta = [], c.forEach((t) => {
				t && w(g(t, !1), "Calendar reference date should be in conversion range!");
				let n = a.get_weeks_in_month(o(m(t))), c = s(0, n), d = s(1, 7), f = c.map((n) => d.map((r) => a.get_day_info({
					weekNum: n,
					weekDayNum: r,
					calendarReferenceDate: o(m(t)),
					date: o(m(e.next[e.next.currentDateSelection])),
					disable_date_before: u,
					disable_date_after: l,
					disabledWeekDays: e.next.disabledWeekDays,
					holidays: e.next.holidays,
					weekSelectionEnabled: e.next.mode === v.WEEK,
					weekAnchorDate: e.next.startDate
				}))), p = m(t);
				console.log(t, p);
				let [h, _] = p.split("-"), y = +h, b = i.ne[_ - 1], [x] = e.next.calendarReferenceDate.split("-"), S = {
					gridDates: f,
					primaryYear: y,
					primaryMonth: b,
					secondaryYear: +x,
					secondaryMonthCombination: r[parseInt(_ + "") - 1]
				};
				e.next.yearGridDatesWithMeta.push(S);
			});
		}
		t();
	}
};
export { E as NepaliStrategy };

//# sourceMappingURL=nepali-strategy.js.map